import React from "react";
import selectedThree from "assets/images/flus/selected-three-que.png";
import selectedOne from "assets/images/flus/Selected-one-que.png";
import selectedTwo from "assets/images/flus/selected-two-que.png";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";
import {
  divVariants,
  fadeVariants,
  staticBounceVariants
} from "shared/components/animations";
const FlusterVote = ({ votePoint, description = "", screens }) => {
  const answerer_player_btn_info = _.get(
    screens,
    "answerer.11_result.info_3",

    "Points"
  );
  const VoteImage = () => {
    if (votePoint === 1) {
      return selectedOne;
    } else if (votePoint === 2) {
      return selectedTwo;
    } else if (votePoint === 3) {
      return selectedThree;
    }
  };
  const imageSource = VoteImage();
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="point-award"
    >
      {!_.isEmpty(description) && (
        <motion.p variants={fadeVariants} className="you-vote">
          {description}
        </motion.p>
      )}
      <motion.img
        src={imageSource}
        variants={staticBounceVariants}
        className="imageSource"
        alt="question-three"
      />
      <motion.p variants={fadeVariants} className="point">
        {votePoint} {answerer_player_btn_info}
      </motion.p>
    </motion.div>
  );
};

export default FlusterVote;
